import { Separator } from "@/client/components/shad/separator";
import { useAppForm } from "../form-context";
import { VectorMapURLBlock } from "./blocks/VectorMapURLBlock";
import { defaultValues, mapFormOptions } from "./shared";
import { FieldGroup } from "@/client/components/shad/field";
import { SatelliteMapURLBlock } from "./blocks/SatelliteMapURLBlock";

import { PositionBlock } from "./blocks/PositionBlock";
import { useMapConfig, useMapConfigUpdate } from "@/client/hooks/useMapQuery";

export const MapConfigForm = () => {
  const { data, isLoading } = useMapConfig();
  const { mutateAsync } = useMapConfigUpdate();

  const form = useAppForm({
    ...mapFormOptions,
    defaultValues: data ?? defaultValues,

    onSubmit: async ({ value }) => {
      console.log("Raw value", value);

      await mutateAsync(value);
    },
  });

  if (isLoading) return <p>Loading...</p>;

  return (
    <form
      id="map-config-form"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <FieldGroup>
        <PositionBlock form={form} />
        <Separator />
        <VectorMapURLBlock form={form} />
        <Separator />
        <SatelliteMapURLBlock form={form} />
        <Separator />

        <form.AppForm>
          <form.SubmitButton label="Save" />
        </form.AppForm>
      </FieldGroup>
    </form>
  );
};
